import Reveal from "./Reveal";

export default Reveal;
